<template>
	<box :customer="true" :autoLoad="true" :ref="boxRef" title="字段" :width="800" :index="0" @hide="hide"
		@submit="submit" moduleName="sourcebill" :store="store" selectType="radio" @boxdataload="boxdataload" />
</template>
<style scoped>
	/* 	.footer_button {
		position: relative;
		width: 100%;
		flex-direction: row;
		align-items: flex-end;
		justify-content: flex-end;
		margin-top: 10px;
	} */
</style>
<script>
	import box from '@_system/components/formcomponents/common/box/index.vue'
	export default {
		props: {
			store: {
				type: Object,
				default: () => {
					return {}
				}
			},
			data: {
				type: Array,
				default: () => {
					return []
				}
			},
			obj: {
				default: () => {
					return null
				}
			},
			type: {
				default: () => {
					return null
				}
			},

		},
		data() {
			return {
				index: 0,
				foreingKey: null,
				boxRef: 'box_' + Math.random(),
				box: null,
				boxConfig: {
					columns: [{
						field: 'FNumber',
						title: '编码',
						render: '$input',
						props: {
							querySearchfield: []
						}
					}, {
						field: 'FName',
						title: '名称',
						render: '$input',
						props: {
							querySearchfield: []
						},
						slots:{
							default({row}){
								if(row.FRECPAYTYPE!==undefined){
									return row.FRECPAYTYPE == 1?<span style="color:#F56C6C" >{row.FName}</span>:<span style="color:#67C23A">{row.FName}</span>
								}
								return row.FName
							}	
						}
					},{
						field: 'ModuleType',
						title: '星空模块',
						render: '$input',
						props: {
							querySearchfield: []
						}
					}],
					pagerConfig: {
						currentPage: 1,
						pageSize: 20,
						enabled: false,
						pageSizes: [10, 20, 50, 200],
						force: false
					},
				},
			}
		},
		created() {

		},
		mounted() {
			let box = this.$refs[this.boxRef]
			box.buttonShow = false
			this.box = box
			this.box.list = this.list
			this.box.show = this.show

			// this.box.checkMethod = ({
			// 	row
			// }) => {
			// 	return !row.reconciliationbilldetailid
			// }

		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},

		methods: {
			show() {
				if (this.box.getTable()) {
					let form = this.box.getTable().getProxyInfo().form
					for (let i in form) {
						form[i] = null
					}
					this.box.getTable().commitProxy('query')
				}
			},
			initList() {
				if (!this.box.gridOptions) {
					this.box.initBox(this.boxConfig)
				}
			},
			list(page, form, other) {
				return new Promise((resolve, reject) => {
					this.$api.sourcebill.jindieextra({
						type: this.type,
						...page,
						...form,
						...other
					}).then((res) => {
						resolve({
							list: res
						})
					}, () => {
						reject()
					})
				})
			},
			boxdataload(e) {
				this.$emit('boxdataload', e)
			},
			submit(e) {
				this.$emit('submit', e)
			},
			hide() {
				this.box.getTable().reloadData([])
				this.$emit('back')
			}
		},
		components: {
			box
		}
	}
</script>